function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem =
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth
    );
    // ADDED BY Karthikeyan - Slider Count

    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

//customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      $(".sticky-atc-bar").css("visibility", "hidden");
      $(".pricestyle").html(not_available_message);
      $(".pricestyle").css("visibility", "visible");
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateVariantMetafields(this.currentVariant); // ADDED BY ANUSHA
    }
  }

  // ADDED BY ANUSHA - code for variant metafield change onclick - start
  updateVariantMetafields(currentVariant) {
    const variants = document.querySelectorAll("[data-variant-id]");
    variants.forEach(function (variant) {
      variant.style.display = "none";
      if (variant.dataset.variantId == currentVariant.id) {
        variant.style.display = "block";
      }
    });
    //First accordion product mf
    var description = $("#tblNodes").find(".description").html();
    var features = $("#tblNodes").find(".features").html();
    var intheboxp = $("#tblNodes").find(".in-the-box-p").html();
    var warranty = $("#tblNodes").find(".warranty").html();

    //Second accordion product mf
    var compat = $("#tblNodes2").find(".compat").html();
    var display = $("#tblNodes2").find(".display").html();
    var processorMainHeading = $("#tblNodes2")
      .find(".processorMainHeading")
      .html();
    var memory = $("#tblNodes2").find(".memory").html();
    var graphics = $("#tblNodes2").find(".graphics").html();
    var power = $("#tblNodes2").find(".power").html();
    var camera = $("#tblNodes2").find(".camera").html();
    var featuresMainHeading = $("#tblNodes2")
      .find(".featuresMainHeading")
      .html();
    var dimensionHeading = $("#tblNodes2").find(".dimensionHeading").html();
    var audio = $("#tblNodes2").find(".audio").html();
    var graphics_proc = $("#tblNodes2").find(".graphics-proc").html();
    var battery_life = $("#tblNodes2").find(".battery-life").html();
    var battery_type = $("#tblNodes2").find(".battery-type").html();
    var water_resist = $("#tblNodes2").find(".water-resist").html();
    var series = $("#tblNodes2").find(".series").html();
    var headphone_fit = $("#tblNodes2").find(".headphone-fit").html();
    var carrying_case = $("#tblNodes2").find(".carrying-case").html();
    var ear_tip_size = $("#tblNodes2").find(".ear-tip-size").html();
    var casing_material = $("#tblNodes2").find(".casing-material").html();
    var model_no_p = $("#tblNodes2").find(".model-no-p").html();
    var year_of_rel_p = $("#tblNodes2").find(".year-of-rel-p").html();
    var ear_cushion = $("#tblNodes2").find(".ear-cushion").html();
    var internet_con_p = $("#tblNodes2").find(".internet-con-p").html();
    var wireless_tech = $("#tblNodes2").find(".wireless-tech").html();
    var bluetoothEn = $("#tblNodes2").find(".bluetoothEn").html();
    var material = $("#tblNodes2").find(".material").html();
    var dimensions = $("#tblNodes2").find(".dimensions").html();
    var design = $("#tblNodes2").find(".design").html();

    //First accordion variant mf
    var in_the_box1 = $(".variant-meta-acco-" + currentVariant.id)
      .find(".in-the-box1-value")
      .html();
    var in_the_box2 = $(".variant-meta-acco-" + currentVariant.id)
      .find(".in-the-box2-value")
      .html();
    var in_the_box3 = $(".variant-meta-acco-" + currentVariant.id)
      .find(".in-the-box3-value")
      .html();
    var in_the_box4 = $(".variant-meta-acco-" + currentVariant.id)
      .find(".in-the-box4-value")
      .html();

    //Second accordion variant mf
    var screen_size = $(".variant-meta-acco-" + currentVariant.id)
      .find(".screen-size-value")
      .html();
    var screen_res = $(".variant-meta-acco-" + currentVariant.id)
      .find(".screen-res-value")
      .html();
    var processor = $(".variant-meta-acco-" + currentVariant.id)
      .find(".processor-value")
      .html();
    var proc_model_no = $(".variant-meta-acco-" + currentVariant.id)
      .find(".proc-model-no-value")
      .html();
    var storage_type = $(".variant-meta-acco-" + currentVariant.id)
      .find(".storage-type-value")
      .html();
    var max_memory = $(".variant-meta-acco-" + currentVariant.id)
      .find(".max-memory-value")
      .html();
    var model_no = $(".variant-meta-acco-" + currentVariant.id)
      .find(".model-no-value")
      .html();
    var year_of_rel = $(".variant-meta-acco-" + currentVariant.id)
      .find(".year-of-rel-value")
      .html();
    var case_mat = $(".variant-meta-acco-" + currentVariant.id)
      .find(".case-mat-value")
      .html();
    var internet_con = $(".variant-meta-acco-" + currentVariant.id)
      .find(".internet-con-value")
      .html();
    var prod_height = $(".variant-meta-acco-" + currentVariant.id)
      .find(".prod-height-value")
      .html();
    var prod_width = $(".variant-meta-acco-" + currentVariant.id)
      .find(".prod-width-value")
      .html();
    var prod_depth = $(".variant-meta-acco-" + currentVariant.id)
      .find(".prod-depth-value")
      .html();
    var watch_case_size = $(".variant-meta-acco-" + currentVariant.id)
      .find(".watch-case-size-value")
      .html();
    var band_type = $(".variant-meta-acco-" + currentVariant.id)
      .find(".band-type-value")
      .html();

    if (
      $.trim(screen_size) === "" &&
      $.trim(screen_res) === "" &&
      $.trim(processor) === "" &&
      $.trim(proc_model_no) === "" &&
      $.trim(storage_type) === "" &&
      $.trim(graphics_proc) === "" &&
      $.trim(battery_life) === "" &&
      $.trim(battery_type) === "" &&
      $.trim(max_memory) === "" &&
      $.trim(water_resist) === "" &&
      $.trim(series) === "" &&
      $.trim(headphone_fit) === "" &&
      $.trim(carrying_case) === "" &&
      $.trim(ear_tip_size) === ""
    ) {
      $(".keyspecs").css("display", "none");
    } else {
      let keyspecs = $(".keyspecs");
      mediaSize_1(keyspecs);
      function mediaSize() {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $(".keyspecs").css("display", "block");
        } else {
          $(".keyspecs").css("display", "flex");
        }
      }
      mediaSize();
      window.addEventListener("resize", mediaSize, false);
    }
    if (
      $.trim(casing_material) === "" &&
      $.trim(model_no) === "" &&
      $.trim(year_of_rel) === "" &&
      $.trim(ear_cushion) === "" &&
      $.trim(model_no_p) === "" &&
      $.trim(year_of_rel_p) === ""
    ) {
      $(".general").css("display", "none");
    } else {
      let general = $(".general");
      mediaSize_1(general);
      function mediaSize() {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $(".general").css("display", "block");
        } else {
          $(".general").css("display", "flex");
        }
      }
      mediaSize();
      window.addEventListener("resize", mediaSize, false);
    }
    if (
      $.trim(internet_con_p) === "" &&
      $.trim(internet_con) === "" &&
      $.trim(wireless_tech) === "" &&
      $.trim(bluetoothEn) === ""
    ) {
      $(".connectivity").css("display", "none");
    } else {
      let connectivity = $(".connectivity");
      mediaSize_1(connectivity);
      function mediaSize() {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $(".connectivity").css("display", "block");
        } else {
          $(".connectivity").css("display", "flex");
        }
      }
      mediaSize();
      window.addEventListener("resize", mediaSize, false);
    }
    if ($.trim(case_mat) === "") {
      $(".material").css("display", "none");
    } else {
      let material = $(".material");
      mediaSize_1(material);
      function mediaSize() {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $(".material").css("display", "block");
        } else {
          $(".material").css("display", "flex");
        }
      }
      mediaSize();
      window.addEventListener("resize", mediaSize, false);
    }
    if (
      $.trim(prod_height) === "" &&
      $.trim(prod_width) === "" &&
      $.trim(prod_depth) === ""
    ) {
      $(".dimensions").css("display", "none");
    } else {
      let dimensions = $(".dimensions");
      mediaSize_1(dimensions);
      function mediaSize() {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $(".dimensions").css("display", "block");
        } else {
          $(".dimensions").css("display", "flex");
        }
      }
      mediaSize();
      window.addEventListener("resize", mediaSize, false);
    }
    if ($.trim(watch_case_size) === "" && $.trim(band_type) === "") {
      $(".design").css("display", "none");
    } else {
      let design = $(".design");
      mediaSize_1(design);
      function mediaSize() {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $(".design").css("display", "block");
        } else {
          $(".design").css("display", "flex");
        }
      }
      mediaSize();
      window.addEventListener("resize", mediaSize, false);
    }
    if (
      $.trim(in_the_box1) === "" &&
      $.trim(in_the_box2) === "" &&
      $.trim(in_the_box3) === "" &&
      $.trim(in_the_box4) === ""
    ) {
      $(".in-the-box-heading").css("display", "none");
    } else {
      let inTheBoxHeading = $(".in-the-box-heading");
      mediaSize_2(inTheBoxHeading);
      function mediaSize() {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          $(".in-the-box-heading").css("display", "block");
        } else {
          $(".in-the-box-heading").css("display", "inline-flex");
        }
      }
      mediaSize();
      window.addEventListener("resize", mediaSize, false);
    }
    if ($.trim(screen_size) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".screen-size-heading")
        .css("display", "none");
      $(".screen-size-h").css("display", "none");
    }
    if ($.trim(screen_res) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".screen-res-heading")
        .css("display", "none");
      $(".screen-res-h").css("display", "none");
    }
    if ($.trim(processor) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".processor-heading")
        .css("display", "none");
      $(".processor-h").css("display", "none");
    }
    if ($.trim(proc_model_no) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".proc-model-no-heading")
        .css("display", "none");
      $(".proc-model-no-h").css("display", "none");
    }
    if ($.trim(storage_type) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".storage-type-heading")
        .css("display", "none");
      $(".storage-type-h").css("display", "none");
    }
    if ($.trim(max_memory) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".max-memory-heading")
        .css("display", "none");
      $(".max-memory-h").css("display", "none");
    }
    if ($.trim(model_no) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".model-no-heading")
        .css("display", "none");
      $(".model-no-h").css("display", "none");
    }
    if ($.trim(year_of_rel) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".year-of-rel-heading")
        .css("display", "none");
      $(".year-of-rel-h").css("display", "none");
    }
    if ($.trim(case_mat) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".case-mat-heading")
        .css("display", "none");
      $(".case-mat-h").css("display", "none");
    }
    if ($.trim(internet_con) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".internet-con-heading")
        .css("display", "none");
      $(".internet-con-h").css("display", "none");
    }
    if ($.trim(prod_height) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".prod-height-heading")
        .css("display", "none");
      $(".prod-height-h").css("display", "none");
    }
    if ($.trim(prod_width) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".prod-width-heading")
        .css("display", "none");
      $(".prod-width-h").css("display", "none");
    }
    if ($.trim(prod_depth) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".prod-depth-heading")
        .css("display", "none");
      $(".prod-depth-h").css("display", "none");
    }
    if ($.trim(watch_case_size) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".watch-case-size-heading")
        .css("display", "none");
      $(".watch-case-size-h").css("display", "none");
    }
    if ($.trim(band_type) === "") {
      $(".variant-meta-acco-" + currentVariant.id)
        .find(".band-type-heading")
        .css("display", "none");
      $(".band-type-h").css("display", "none");
    }

    function mediaSize_1(className) {
      if (window.matchMedia("(max-width: 1024px)").matches) {
        $(className).css("display", "block");
      } else {
        $(className).css("display", "flex");
      }
    }
    function mediaSize_2(className) {
      if (window.matchMedia("(max-width: 1024px)").matches) {
        $(className).css("display", "block");
      } else {
        $(className).css("display", "inline-flex");
      }
    }

    function isEmpty(el) {
      return !$.trim(el.html());
    }

    let all_are_hidden1 = true;
    let all_are_hidden2 = true;
    $("#tblNodes .transparent_2").each(function () {
      if ($(this).css("display") !== "none") {
        all_are_hidden1 = false;
        return false;
      }
    });
    if (all_are_hidden1 == true) {
      $(".overviewAccordion").css("display", "none");
    } else {
      $(".overviewAccordion").css("display", "block");
    }

    $("#tblNodes2 .transparent_3").each(function () {
      if ($(this).css("display") !== "none") {
        all_are_hidden2 = false;
        return false;
      }
    });
    if (all_are_hidden2 == true) {
      $(".specificationAccordion").css("display", "none");
    } else {
      $(".specificationAccordion").css("display", "block");
    }

    if (
      $(".specificationAccordion").css("display") == "none" &&
      $(".overviewAccordion").css("display") == "none"
    ) {
      $(".container_X").css("display", "none");
    } else {
      $(".container_X").css("display", "block");
    }

    if (isEmpty($("#tblNodes"))) {
      $(".overviewAccordion").css("display", "none");
    }

    if (isEmpty($("#tblNodes2"))) {
      $(".specificationAccordion").css("display", "none");
    }
  } // ADDED BY ANUSHA - code for variant metafield change onclick - end

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (this.currentVariant.featured_media.id) {
      //const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    }
    //ADDED BY Karthikeyan - code for variant image
    //if(newMediaModal !== null) {
    //modalContent.prepend(newMediaModal);
    //}
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    //added by Hema
    $("#main-pro-sku").val(this.currentVariant.sku);
    $("#main-pro-sku-mobile").val(this.currentVariant.sku);

    //added by anusha-for sku title -start
    $("#skutitle1").val(this.currentVariant.sku);
    $("#skutitle2").val(this.currentVariant.sku);
    if (this.currentVariant.sku == null || this.currentVariant.sku == "") {
      $("#skutitle1").css("display", "none");
      $("#skutitle2").css("display", "none");
    } else {
      $("#skutitle1").css("display", "block");
      $("#skutitle2").css("display", "block");
    } //added by anusha-for sku title -end

    //Souvik Code for monthly price - desktop starts
    var actual_currency = $("#price-element").find(".actual_price_bold").text();
    var currency_1 = actual_currency
      .trim()
      .replace(/[\d\., ]/g, " ")
      .toString();
    var value = document.getElementById("price_mon_section");
    var value_mb = document.getElementById("price_mon_section_mb");
    if (value) {
      var monthValue = value.getAttribute("value");
      var month = parseInt(monthValue);
      var currentVariant = this.currentVariant.price;
      if (vat_free_day == true) {
        var vatDisPercent1 = parseFloat(vat_discount_amount) / 100;
        var vatAmount1 = parseInt(currentVariant) * parseFloat(vatDisPercent1);
        var currentVariant = parseInt(currentVariant) - parseFloat(vatAmount1);
      }

      currentVariant = currentVariant.toString();
      currentVariant = currentVariant.slice(0, -2);
      currentVariant = parseInt(currentVariant);
      // $('.price_mon_section').text((currentVariant/month).toFixed(2));
      var am1 = (currentVariant / month).toFixed(2);
      var am2 = currency_1.replace(" ", am1);
      //$('.price_mon_section').text(am2);
    }
    //Souvik Code for monthly price - desktop ends

    //Anusha Code for monthly price - mobile starts
    if (value_mb) {
      var monthValue_mb = value_mb.getAttribute("value");
      var month_mb = parseInt(monthValue_mb);
      var currentVariant_mb = this.currentVariant.price;
      if (vat_free_day == true) {
        var vatDisPercent1_mb = parseFloat(vat_discount_amount) / 100;
        var vatAmount1_mb =
          parseInt(currentVariant_mb) * parseFloat(vatDisPercent1_mb);
        var currentVariant_mb =
          parseInt(currentVariant_mb) - parseFloat(vatAmount1_mb);
      }
      currentVariant_mb = currentVariant_mb.toString();
      currentVariant_mb = currentVariant_mb.slice(0, -2);
      currentVariant_mb = parseInt(currentVariant_mb);
      var am3 = (currentVariant_mb / month_mb).toFixed(2);
      var am4 = currency_1.replace(" ", am3);
    }
    //Anusha Code for monthly price - mobile ends

    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );

    $(".variant-all-image").each(function () {
      $(this).css("display", "none");
    });
    $(".variant-meta-image").each(function () {
      $(this).css("display", "none");
    });
    $(".default-variant-image").css("display", "none");
    $(".is-active").css("display", "block");
    $(".product-media-modal__content img").each(function () {
      $(this).hide();
    });
    $(".product-media-modal__content video").each(function () {
      $(this).hide();
    });
    $(".product-media-modal__content deferred-media").each(function () {
      $(this).hide();
    });
    var c1 = parseInt(
      $(".variant-listed-image-" + this.currentVariant.id).length
    );
    if (this.currentVariant.featured_media) {
      var c2 = parseInt(
        $(".variant-comapre-image-" + this.currentVariant.featured_media.id)
          .length
      );
    } else {
      var c2 = 0;
    }

    var c3 = c1 + c2;
    if (c3 == 0) {
      $(".common_medias").each(function () {
        $(this).css("display", "block");
      });
      $(".variant-meta-image").each(function () {
        $(this).css("display", "none");
      });
      $(".slider_media").slick("unslick");
      $(".slider_media").html("");
      $(".common_medias").each(function () {
        var data = $(this).find(".product__media").html();
        $(".slider_media").append("<li>" + data + "</li>");
      });
      $(".slider_media").slick({
        prevArrow: '<button class="slide-arrow prev-arrow">&#60;</button>',
        nextArrow: '<button class="slide-arrow next-arrow">&#62;</button>',
      });
      // On slide change, pause all videos
      $(".slider_media").on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          $("video").each(function () {
            $(this).get(0).pause();
          });
        }
      );

      // On slide chnage, play a video inside the current slide
      $(".slider_media").on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          if ($(".slick-current").find("video").length !== 0) {
            $(".slider_media .slick-current video")[0].play();
          }
        }
      );
      $(".product-media-modal__content img")
        .not(".custom_media_images")
        .each(function () {
          $(this).show();
        });
      $(".product-media-modal__content deferred-media").each(function () {
        $(this).show();
      });
      $(".product-media-modal__content deferred-media video").each(function () {
        $(this).show();
      });
      return;
    }

    $(".variant-listed-image-" + this.currentVariant.id).each(function () {
      $(this).css("display", "block");
    });

    $(".slider_media").slick("unslick");
    $(".slider_media").html("");
    if (this.currentVariant.featured_media) {
      var data = $(
        ".variant-comapre-image-" + this.currentVariant.featured_media.id
      )
        .find(".product__media")
        .html();
      $(".slider_media").append("<li>" + data + "</li>");
    }
    $(".variant-listed-image-" + this.currentVariant.id).each(function () {
      var data = $(this).find(".product__media").html();
      $(".slider_media").append("<li>" + data + "</li>");
    });

    $(".slider_media").slick({
      prevArrow: '<button class="slide-arrow prev-arrow">&#60;</button>',
      nextArrow: '<button class="slide-arrow next-arrow">&#62;</button>',
    });
    // On slide change, pause all videos
    $(".slider_media").on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        $("video").each(function () {
          $(this).get(0).pause();
        });
      }
    );

    // On slide chnage, play a video inside the current slide
    $(".slider_media").on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        if ($(".slick-current").find("video").length !== 0) {
          $(".slider_media .slick-current video")[0].play();
        }
      }
    );
    $(
      ".product-media-modal__content img.custom_popup_" + this.currentVariant.id
    ).each(function () {
      $(this).show();
    });
    if (this.currentVariant.featured_media) {
      $(
        ".product-media-modal__content img.custom_popup_compare_" +
          this.currentVariant.featured_media.id
      ).each(function () {
        $(this).show();
      });
    }
    $(
      ".product-media-modal__content video.custom_popup_" +
        this.currentVariant.id
    ).each(function () {
      $(this).show();
    });
    if (this.currentVariant.featured_media) {
      $(
        ".product-media-modal__content video.custom_popup_compare_" +
          this.currentVariant.featured_media.id
      ).each(function () {
        $(this).show();
      });
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      const variantName = document.getElementById(
        "mpn_handle_" + this.currentVariant.id
      ).value;
      const mpninput = document.getElementById("mpn_handle");
      mpninput.value = variantName;
      mpninput.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      //Hema added code for pickup msg on out of stock
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      //Hema added code for pickup msg on out of stock
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
      $("pickup-availability").css("display", "none");
    }
    //$('.product__pickup-availabilities').css('display','block');
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        //Souvik Code for monthly price - desktop starts
        $("#price_mon_section").html($(html).find("#price_mon_section").html());
        //Souvik Code for monthly price - desktop ends
        //Anusha Code for monthly price - mobile starts
        $("#price_mon_section_mb").html(
          $(html).find("#price_mon_section_mb").html()
        );
        //Anusha Code for monthly price - mobile starts
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );

        // SKU CODE ADDED BY ANUSHA -------- START
        const sku = `sku-${this.dataset.section}`;
        const last = document.getElementById(sku);
        const first = html.getElementById(sku);
        if (first && last) last.innerHTML = first.innerHTML;
        const sku2 = document.getElementById(`sku-${this.dataset.section}`);

        // SKU CODE ADDED BY ANUSHA -------- END

        // Pricing CODE ADDED BY HEMA -------- START
        let price_footer = price.innerHTML;
        $("#price-element").text("");
        var textreplace = "<div id='price-footer-element'></div>";
        $("#price-element").append(textreplace);
        $("#price-footer-element").replaceWith(price_footer);
        // Pricing CODE ADDED BY HEMA -------- END

        if (vat_free_day == true) {
          var vat_price_footer = $(".pricestyle")
            .find(".vat_price_bold")
            .text();
          if (vat_price_footer != "") {
            // $("#price-element").find(".actual_price_bold").css("display", "none");
            $("#price-element").find(".footerOr2").css("display", "none");
          }
        }

        $(".product__pickup-availabilities").css("display", "block");

        if (this.currentVariant && this.currentVariant.available) {
          //Hema added code for out of stock
          $(".show_atc a").show();
          $(".show_buy a").show();
          $(".hide---atc a").hide();
          $(".hide---atc span").hide();
          $(".free_shipping_msg").show();
          $(".free_shipping_msg_2").show();
          $("pickup-availability").css("display", "block");
          $(".four-buynow").addClass("four-atc");
          $(".applyforFinancing").show();
          $(".sticky-container").removeClass("outofstock_sc");
        } else {
          //Hema added code for out of stock
          $(".hide---atc a").show();
          $(".hide---atc span").show();
          $(".show_atc a").hide();
          $(".show_buy a").hide();
          $(".free_shipping_msg").hide();
          $(".free_shipping_msg_2").hide();
          $("pickup-availability").css("display", "none");
          $(".four-buynow").removeClass("four-atc");
          $(".applyforFinancing").hide();
          $(".sticky-container").addClass("outofstock_sc");
        }
        $(".sticky-atc-bar").css("visibility", "visible");
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;

      // $('.hide---atc button').show();
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;

      // $('.hide---atc button').hide();
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

//Souvik Button color change on pressed starts
//carousel Button
$(document).ready(function () {
  $(".button_primary_anchor").click(function () {
    var id = this.id;
    var par = $(this).parent().attr("id");
    $("#" + par).addClass("button_primary_clicked_clicked");
  });
});

//whatsnew richtext2 button & image with text 2 button
$(document).on("click", ".button_primary_clicked", function () {
  var id = this.id;
  $("#" + id).addClass("button_primary_clicked_clicked");
});

//image with text 3 button
$(document).on("click", ".button_primary_clicked_hollow", function () {
  var id = this.id;
  $("#" + id).addClass("button_primary_clicked_hollow_clicked");
});
//Souvik Button color change on pressed ends

//Souvik Frequently brought together height adjust starts
$(window).load(function () {
  var height;
  var maxheight = 0;
  var minheight = 0;

  $(".price_container_cal").each(function () {
    height = parseInt($(this).height());

    if (height > maxheight) {
      maxheight = height;
    } else {
      minheight = height;
    }
  });

  let isMobile = window.matchMedia(
    "only screen and (max-width: 1023px)"
  ).matches;
  if (!isMobile) {
    if (maxheight >= minheight) {
      $(".price_container_cal").attr(
        "style",
        "display: flex; flex-flow: column; justify-content: flex-end; height:" +
          maxheight +
          "px;"
      );
    }
  }

  // you may like carousel code

  var collection = new Array();
  $(".collection_name").each(function () {
    if ($(this).text() != "") collection.push($(this).text().toLowerCase());
  });

  $.each(collection, function (index, value) {
    var height;
    var maxheight = 0;
    var minheight = 100;
    jQuery(".price__container_" + value).each(function () {
      height = parseInt($(this).height());
      if (height > maxheight) {
        maxheight = height;
      }
    });
    if (maxheight > 22) {
      jQuery(".price__container_" + value).attr(
        "style",
        "display: flex; flex-flow: column; justify-content: flex-end; height:" +
          maxheight +
          "px;"
      );
    }
  });

  var height1 = 0;
  var maxheight1 = 0;
  $(".price__container_").each(function () {
    height1 = parseInt($(this).height());
    if (height1 > maxheight1) {
      maxheight1 = height1;
    }
  });
  if (maxheight1 > 22) {
    jQuery(".price__container_").attr(
      "style",
      "display: flex; flex-flow: column; justify-content: flex-end; height:" +
        maxheight1 +
        "px;"
    );
  }

  //sold out button on sliders
  $(".button_disabled").each(function () {
    $(this).parent().addClass("card-slider-buttons-disabled");
  });
});

//Souvik Frequently brought and you may like carousel height adjust ends
